var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Undo",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <g id="svg-fg">
    <path d="M38.51,23.63A12.83,12.83,0,0,0,30.26,22l-.14,0,.13-.17,2.31-3a1.7,1.7,0,0,0,.35-1.45,1.74,1.74,0,0,0-3.13-.66l-5.12,6.58A1.73,1.73,0,0,0,25,25.81q3.29,2.56,6.6,5.1a2.25,2.25,0,0,0,.94.41,1.69,1.69,0,0,0,1.79-1,1.74,1.74,0,0,0-.5-2.06c-1-.8-2-1.58-3.05-2.37l-.29-.24v0c.34,0,.68,0,1,0a8.87,8.87,0,0,1,7.15,2.76A9.37,9.37,0,1,1,22.78,37c-.08-.35-.13-.71-.23-1.05a1.79,1.79,0,0,0-2.19-1.27A1.84,1.84,0,0,0,19,36.74a12.78,12.78,0,0,0,7,9.81,13,13,0,0,0,16.34-3.7,13.57,13.57,0,0,0,2.18-4.38A13,13,0,0,0,38.51,23.63Z"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/assets/icons/undo.svg